// Canonical meeting-role + capability model (frontend ESM).
// Single source of truth lives in roles.json; the backend reads the same file
// via roles.cjs so the two layers can't drift. See group video chat plan §2.5.
import rolesData from './roles.json';

export const ROLES = rolesData.roles;
export const DEFAULT_ROLE = rolesData.defaultRole;

/** All valid role keys, e.g. ['host', 'presenter', 'guest', 'observer']. */
export const ROLE_KEYS = Object.keys(ROLES);

/** Whether `role` is a known role key. */
export function isValidRole(role) {
  return typeof role === 'string' && Object.prototype.hasOwnProperty.call(ROLES, role);
}

/** Human-readable label for a role, falling back to the raw key. */
export function roleLabel(role) {
  return ROLES[role]?.label || role || '';
}

/** Whether `role` grants `capability` (e.g. 'shareScreen', 'publishVideo'). */
export function can(role, capability) {
  return Boolean(ROLES[role]?.capabilities.includes(capability));
}
